module.exports = __webpack_public_path__ + "static/img/bg.7b9c16e8.png";